import { useState, useEffect, useContext } from 'react'
import { Spin } from 'antd'
import styles from '../../index.module.less'
import Top from './components/Top'
import callContext from '@/pages/crm/callCenter/callManage/callManageContext'
import Bottom from './components/Bottom'
import {getActiveBtn, getHandleButtonObj, processButtonData} from '@/utils/btn.ts'
import {getClueDetail, getDetailByCall} from '@/services/callCenter'
import dayjs from 'dayjs'
import {getClueButton} from "@/services/saleOpServices.ts";

function MainRight() {
  const { updateCallManageState, callManageState } = useContext(callContext)
  const [loading, setLoading] = useState(false) //详情数据加载
  const [isBtnObj, setIsBtnObj] = useState({}) // 按钮权限
  const { detailParameter, detailRefresh, clueStatusEnum } = callManageState

  useEffect(() => {
    if (detailParameter.id) {
      setIsBtnObj({})
      fetchDetailData(detailParameter)
      fetchPermission()
    }
  }, [detailParameter.id, detailRefresh])

  // 请求按钮权限
  const fetchPermission = async () => {
    const arr = await getClueButton(detailParameter.id)
    console.log(arr, 1111)
    const isBtnObj = await getHandleButtonObj(arr)
    if (isBtnObj) setIsBtnObj({ ...isBtnObj })
  }
  
  // 请求详情数据
  const fetchDetailData = (data: any) => {
    setLoading(true)
    getClueDetail(data.id)
      .then((res: any) => {
        if (res?.dispatchTime)
          res.dispatchTime = dayjs(res?.dispatchTime).format('YYYY-MM-DD HH:mm:ss')
        if (res?.signTime) res.signTime = dayjs(res?.signTime).format('YYYY-MM-DD HH:mm:ss')
        if (res?.createdTime)
          res.createdTime = dayjs(res?.createdTime).format('YYYY-MM-DD HH:mm:ss')
        if (res?.expectRenovationDate)
          res.expectRenovationDate = dayjs(res?.expectRenovationDate).format('YYYY-MM-DD HH:mm:ss')
        if (res?.firstVisitDate)
          res.firstVisitDate = dayjs(res?.firstVisitDate).format('YYYY-MM-DD HH:mm:ss')
        if (res?.giveHouseDate)
          res.giveHouseDate = dayjs(res?.giveHouseDate).format('YYYY-MM-DD')

        if (res?.constructionArea) res.constructionArea = res.constructionArea + 'm²'
        if (res?.inHouseSize) res.inHouseSize = res.inHouseSize + 'm²'
        if(!res?.remark) res.remark=''
        updateCallManageState({
          callDetails: res,
          TSDetailId: res?.id,
        })
      })
      .catch((e: any) => {
        updateCallManageState({
          callDetails: {},
        })
      })
      .finally(() => {
        setLoading(false)
      })
  }
  return (
    <div className={styles.mainRight}>
      <Spin tip="Loading" size="small" spinning={loading}>
        <Top isBtnObj={isBtnObj} />
        <Bottom />
      </Spin>
    </div>
  )
}

export default MainRight
